<style>
@import '../../custom/css/cria-dicas.css';
</style>

<template>
  <div id="cria-produtos" class="cria-dicas">
    <h1 class="title text-uppercase font-weight-bold">Criar Produto</h1>
    <hr class="linha-amarela" />
    <div class="form-group">
      <label for="titulo">Título</label>
      <input
        type="text"
        class="form-control"
        id="titulo"
        v-model="produto.nome"
      />
    </div>
    <div class="form-group">
      <label for="titulo">Descrição</label>
      <textarea
        class="form-control"
        id="descricao"
        v-model="produto.descricao"
      ></textarea>
    </div>
    <div class="form-group">
      <label for="titulo">Segmento</label>
      <select v-model="produto.id_segmento" class="form-control">
        <option value="disabled" disabled>Segmento</option>
        <option
          v-for="segmento in segmentos"
          v-bind:value="segmento.id"
          v-bind:key="segmento.id"
        >
          {{ segmento.nome }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <label for="titulo">Unidade de Medida</label>
      <select v-model="produto.id_unidade" class="form-control">
        <option value="disabled" disabled>Unidades de Medida</option>
        <option
          v-for="medida in tipoMedidas"
          v-bind:value="medida.id"
          v-bind:key="medida.id"
        >
          ({{ medida.nome }}) {{ medida.descricao }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <div class="btn btn-success" @click="criarProduto()">Criar</div>
      <div class="btn btn-voltar-dicas" @click="voltarLista()">Voltar</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'cria-produtos',
  data: () => ({
    selectedDay: '1',
    produto: {
      nome: null,
      id_segmento: 'disabled',
      id_unidade: 'disabled',
    },
  }),
  computed: {
    ...mapGetters(['getTipoNotification', 'getNotification']),
    ...mapState({
      dadosUsuario: (state) => state.dadosUsuario,
      // produtos
      segmentos: (state) => state.segmentos,
      tipoMedidas: (state) => state.tipoMedidas,
    }),
  },
  created() {
    this.$store.dispatch('loadSegmentos');
    this.$store.dispatch('loadTipoMedidas');
  },
  methods: {
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    criarProduto() {
      // verifica se os selects estão vazios
      if (this.produto.id_segmento == 'disabled') {
        this.aviso('Selecione um segmento', 'warning');
        return;
      }
      if (this.produto.id_unidade == 'disabled') {
        this.aviso('Selecione uma unidade de medida', 'warning');
        return;
      }

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('insertProduto', this.produto)
        .then((data) => {
          setTimeout(() => {
            if (this.getTipoNotification == 1) {
              this.$store.dispatch('endloaderLoader');
              this.aviso(this.getNotification, 'success');
              setTimeout(() => {
                this.$router.push({ name: 'administrador-lista-produtos' });
              }, 1500);
            } else if (this.getTipoNotification == 3) {
              this.aviso(this.getNotification, 'danger');
            }
          }, 1000);
        })
        .catch(() => {
          this.$store.dispatch('endloaderLoader');
        });
    },
    voltarLista() {
      this.$router.push({
        name: 'administrador-lista-produtos',
      });
    },
  },
};
</script>
